import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { BehaviorSubject } from 'rxjs';


export class HioDeviceState {
  public type: 'mobile' | 'tablet' | 'desktop' = 'desktop';
  public size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'xs';
}


@Injectable({
  providedIn: 'root'
})
export class HioDeviceService  {
  public state = new BehaviorSubject(new HioDeviceState());
  public signalState = toSignal(this.state);
  
  constructor() {

    this.calcDevice();
    let doit;
    window.addEventListener('resize', () => {
      clearTimeout(doit);
      doit = setTimeout(() => {this.calcDevice();}, 100);
    });

  }

  canActivate() : boolean {
    return true;
  }

  private calcDevice() {
    let state = {...this.state.value};

    let width = window.innerWidth < window.innerHeight ? window.innerWidth : window.innerHeight;
    if (width < 480) {
      state.type = 'mobile';
    } else if (width < 1024) {
      state.type = 'tablet';
    } 
    if (window.innerWidth >= 1024) {
      state.type = 'desktop';
    }

    let screenWidth = screen.availWidth;
    if (screenWidth < 600) {
      state.size = 'xs';
    } else if (screenWidth < 960) {
      state.size = 'sm';
    } else if (screenWidth < 1280){
      state.size = 'md';
    } else if (screenWidth < 1920){
      state.size = 'lg';
    } else {
      state.size = 'xl';
    }

    this.state.next(state);
  }

}
